/**
 * Creates error handlers for iframe load events
 */
export const createIframeEventHandlers = (
  onLoad: () => void,
  onError: () => void,
) => {
  const handleLoad = () => {
    onLoad();
  };

  const handleError = () => {
    onError();
  };

  return {
    handleLoad,
    handleError,
  };
};
